$(() => {
  const key = 'clear-on-click';
  $(`[data-${key}]`).on('click', function() {
    $($(this).data(key)).val('');
  });
});
